import { render, staticRenderFns } from "./JtCardDefault.vue?vue&type=template&id=11fafc2a&scoped=true"
import script from "./JtCardDefault.vue?vue&type=script&lang=js"
export * from "./JtCardDefault.vue?vue&type=script&lang=js"
import style0 from "./JtCardDefault.vue?vue&type=style&index=0&id=11fafc2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fafc2a",
  null
  
)

export default component.exports